import { BUTTON_LEVELS } from '@/services/auth/consts'

// 권한관리(MA03) 화면 상수 — 배선(index.tsx)·데이터 훅(queries/)이 쓰는 계약. UI(컬럼·필터)는 컨덕터 생성본이 정본이라 여기 두지 않는다.

export const MESSAGES = {
  noShipper: '화주명을 선택해 주세요.',
  noSelection: '저장할 행을 선택해 주세요.',
  noDeleteSelection: '삭제할 행을 선택해 주세요.',
  requiredHeadCells: '화주코드·권한코드·권한명은 필수입니다.',
  /** 1.0 MA03_ITEM 필수는 허용여부 하나(gridsub required) — 메뉴코드는 행 키라 비우면 아래 itemKeyLocked 가 막는다. */
  requiredItemCells: '허용여부는 필수입니다.',
  shipperLocked: '다른 화주의 권한은 저장할 수 없습니다.',
  keyLocked: '기존 권한의 화주코드·권한코드는 바꿀 수 없습니다(권한명만 수정됩니다).',
  itemKeyLocked: '메뉴코드는 바꿀 수 없습니다(허용여부·버튼권한·필터여부만 수정됩니다).',
  noMaster: '상단에서 권한을 먼저 선택해 주세요.',
  itemDeleteNoApi: '메뉴 권한 삭제는 지원하지 않습니다(권한 생성 시 전체 메뉴가 매핑되고, 비활성은 허용여부 N).',
  itemAddNoApi: '메뉴 권한 추가는 지원하지 않습니다(권한 생성 시 전체 메뉴가 자동 매핑됩니다).',
  shipperLoadFailed: '화주 목록을 불러오지 못했습니다. 새로고침한 뒤 다시 시도해 주세요.',
} as const

// 메뉴 권한(하단 표) 편집 셀 선택지 — 생성본 데모 대신 BE 계약 값으로 고정한다.
// 버튼권한은 1.0 콤보(BUTTON_LV)와 같은 LV1~LV4 — LV4 저장은 moms-be LOGISPRD-16729 배포 전까지 400.
// 허용·필터여부는 Y/N 을 boolean 으로 바꿔 보낸다(index.tsx 저장 슬롯).
export const YN_OPTIONS = ['Y', 'N'].map((v) => ({ value: v, label: v }))
export const BUTTON_LEVEL_OPTIONS = BUTTON_LEVELS.map((v) => ({ value: v, label: v }))

export interface AuthMenuRow {
  AUTH_CD: string
  MENU_LV: number
  MENU_TREE?: string
  MENU_CD: string
  MENU_NM: string
  MENU_ACT: string
  BUTTON_LV: string
  FILTER_YN: string
  INS_DATE: string
  INS_BY: string
  UPD_DATE: string
  UPD_BY: string
}

// schema n-item-table editCascade — MENU_ACT 편집 시 트리 전파 규칙(상위 N → 하위 전부 N · 하위 Y → 상위 Y 복원)
export const ITEM_EDIT_CASCADE = {
  field: 'MENU_ACT',
  keyField: 'MENU_CD',
  treeField: 'MENU_TREE',
  parentFlag: { field: 'MENU_LV', value: 1 },
  downValue: 'N',
  upValue: 'Y',
} as const
